import {ISubNavLink} from "modules/types/routing";
import {Language} from "modules/enums";
import {GAME_ZONE_URL, IS_FAN_VOTE_DISABLED} from "./environment";

export const subMenuRouting: ISubNavLink[] = [
	{
		title: "sub_header.links.team",
		href: "/picks",
		isEnabled: true,
	},
	{
		title: "sub_header.links.fan_vote",
		href: "/fan-vote",
		isEnabled: !IS_FAN_VOTE_DISABLED,
	},
	{
		title: "sub_header.links.stats",
		href: "/stats",
		isEnabled: true,
		urls: [
			{
				title: "sub_header.links.league_leaders",
				href: "/league-leaders",
			},
			{
				title: "sub_header.links.advanced_stats",
				href: "/stats",
			},
		],
	},
	{
		title: "sub_header.links.help",
		href: `/help`,
		isEnabled: true,
	},
];

export const SelectProjectTitle = "sub_header.projects.allstar";

export const subMenuProjectLinksEn = [
	{
		title: "sub_header.projects.gz",
		href: GAME_ZONE_URL,
	},
	{
		title: "sub_header.projects.fantasy",
		href: GAME_ZONE_URL + "fantasy/",
	},
	{
		title: "sub_header.projects.pickem",
		href: GAME_ZONE_URL + "pickem/",
	},
	{
		title: "sub_header.projects.blitzpicks",
		href: GAME_ZONE_URL + "blitzpicks/",
	},
	{
		title: "sub_header.projects.futures",
		href: GAME_ZONE_URL + "futures/",
	},
	{
		title: "sub_header.projects.team_quiz",
		href: GAME_ZONE_URL + "teampicker/",
	},
	{
		title: "sub_header.projects.vote",
		href: GAME_ZONE_URL + "fanoftheyear/baffin/",
	},
];

export const subMenuProjectLinksFr = [
	{
		title: "sub_header.projects.gz",
		href: GAME_ZONE_URL,
	},
	{
		title: "sub_header.projects.fantasy",
		href: GAME_ZONE_URL + "fantasy/",
	},
	{
		title: "sub_header.projects.pickem",
		href: GAME_ZONE_URL + "pickem/",
	},
	{
		title: "sub_header.projects.blitzpicks",
		href: GAME_ZONE_URL + "blitzpredictions/",
	},
	{
		title: "sub_header.projects.futures",
		href: GAME_ZONE_URL + "predictionsavantsaison/",
	},
	{
		title: "sub_header.projects.team_quiz",
		href: GAME_ZONE_URL + "selectionneurequipe/",
	},
	{
		title: "sub_header.projects.vote",
		href: GAME_ZONE_URL + "partisandelannee/baffin/",
	},
];

export const subMenuProjectLinks = {
	[Language.English]: subMenuProjectLinksEn,
	[Language.French]: subMenuProjectLinksFr,
};
